<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="message !== undefined"
      :class="{
        opened: opened.indexOf('showMessage') >= 0,
        'last-active': opened.indexOf('showMessage') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="closeBox('showMessage')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
      </div>
      <div class="side-box__title">
        <h2>
          <span v-if="message.type == 'up'">{{ $t("zpravaZeZarizeni") }}</span>
          <span v-if="message.type == 'down'">{{ $t("zpravaDoZarizeni") }}</span>
          <span v-if="device">&nbsp;{{ device.custDeviceName }}</span>
        </h2>
      </div>
      <div v-if="message.message" class="side-box__content">
        <div v-if="message.messageStatus === 'suspended'" class="messages__suspended font-weight-bold">
          {{ $t("MESSAGE_SUSPENDED") }}
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("datum") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.date(message.messageTime)" />
        </div>
        <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("casOdeslani") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.time(message.messageTime)" />
        </div>
        <div v-if="message.type == 'down'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("casOdeslani") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.time(message.messageTime)" />
        </div>
        <div v-if="deviceType !== 'MQTT'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("casPrijetiDoNS") }}</span>
          <span class="side-box__content__value ml-3" v-html="$filters.timestampToTime(message.message.ts)" />
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("typZpravy") }}</span>
          <span class="side-box__content__value ml-3">
            <span v-if="message.type == 'up'">
              <img class="mr-2" src="@/assets/icons/arrows/ico-ico-zezarizeni.svg" />
              {{ $t("zeZarizeni") }}
            </span>
            <span v-else>
              <img class="mr-2" src="@/assets/icons/arrows/ico-ico-dozarizeni.svg" />
              {{ $t("doZarizeni") }}
            </span>
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">
            {{ $t("stav") }}
          </span>
          <span class="side-box__content__value ml-3">
            <span v-if="item.messageStatus == 'suspended'" class="atom-tag atom-tag--muted">
              {{ $t("MSG_SUSPENDED") }}
            </span>
            <span v-else-if="message.state === 'inFront'" class="atom-tag">
              {{ $t("veFronte") }}
            </span>
            <span v-else-if="message.state === 'OK'" class="atom-tag atom-tag--success">OK</span>
            <span v-else-if="message.state === 'TEST'" class="atom-tag atom-tag--success">TEST</span>
            <span v-else class="atom-tag atom-tag--warning">?</span>
          </span>
        </div>
        <div v-if="deviceType !== 'MQTT'" class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("port") }}</span>
          <span class="side-box__content__value ml-3">
            {{ message.message.port }}
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("nazevZarizeni") }}</span>
          <span v-if="device" class="side-box__content__value ml-3">
            {{ device.custDeviceName }}
          </span>
          <span v-if="message.device">
            <RouterLink
              :to="{
                name: 'device',
                params: { id: message.device.deviceId, device: message.device }
              }"
              class="font-weight-bolder link-gray"
            >
              <span>{{ message.device.custDeviceName }}</span>
            </RouterLink>
          </span>
        </div>
        <div class="side-box__row d-flex align-items-center mt-3">
          <span class="side-box__content__label text gray-text">{{ $t("idZarizeni") }}</span>
          <span v-if="device" class="side-box__content__value ml-3">
            {{ device.deviceId }}
          </span>
        </div>
        <div v-if="deviceType !== 'MQTT'">
          <div v-if="message.type === 'up'" class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label text gray-text">{{ $t("pocetGateways") }}</span>
            <span v-if="message.message.gws" class="side-box__content__value ml-3">
              {{ message.message.gws.length }}
            </span>
          </div>
          <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label text gray-text">{{ $t("baterie") }}</span>
            <span v-if="message.message" class="side-box__content__value ml-3">
              <span v-if="message.message.bat > 0 && message.message.bat < 255" class="d-flex align-items-center">
                {{ Math.round((message.message.bat / 254) * 100, 2) }}
                %
              </span>
              <span v-if="message.message.bat == 0">AC</span>
              <span v-if="message.message.bat == 255 || message.message.bat == null">N/A</span>
            </span>
          </div>
          <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label text gray-text">{{ $t("RSSI") }}</span>
            <span v-if="message.message.gws" class="side-box__content__value ml-3">
              <RssiIcon :last-message-in="message" />
            </span>
          </div>
          <div v-if="message.type == 'up'" class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label text gray-text">{{ $t("SNR") }}</span>
            <span v-if="message.message.gws" class="side-box__content__value ml-3">
              <SnrIcon :last-message-in="message" />
            </span>
          </div>
        </div>
        <div v-if="message.messageStatus !== 'suspended'" class="border-top mt-4 pt-4">
          <div class="d-flex justify-content-between">
            <strong class="text-large">{{ $t("obsahZpravy") }}</strong>
            <a @click="exportMessages('xlsx')">{{ $t("stahnoutXLS") }}</a>
          </div>
          <div class="mt-4" style="white-space: pre-wrap; overflow: auto">
            {{ message.message }}
          </div>
          <!--div v-for="(line,index) in message.message.split(',')" :key="index+'message'">{{line}}</div-->
        </div>

        <div v-if="message.type == 'up'" class="justify-content-left border-top mt-4 pt-4 pb-4">
          <div v-if="item.transformationId" class="mb-1">
            {{ $t("MESSAGE_PROCESSED_DEVICE_TF") }}:
            <strong>
              {{ usedTransformations?.find((tf) => tf.transformationId === item.transformationId)?.label }}
            </strong>
          </div>
          <div v-if="item.hwDeviceTransformationId" class="mb-1">
            {{ $t("MESSAGE_PROCESSED_PAYLOAD_TF") }}:
            <strong>
              {{ usedTransformations?.find((tf) => tf.transformationId === item.hwDeviceTransformationId)?.label }}
            </strong>
          </div>
          <div v-if="item.groupTransformationId" class="mb-1">
            {{ $t("MESSAGE_PROCESSED_GROUP_TF") }}:
            <strong>
              {{ usedTransformations?.find((tf) => tf.transformationId === item.groupTransformationId)?.label }}
            </strong>
          </div>
          <div>
            <button class="btn btn-primary" @click="showOriginalMessage = showOriginalMessage ? false : true">
              <span v-if="!showOriginalMessage">
                {{ $t("BTN_SHOW_ORIGINAL_MESSAGE") }}
              </span>
              <span v-else>
                {{ $t("BTN_HIDE_ORIGINAL_MESSAGE") }}
              </span>
            </button>
            <div v-if="showOriginalMessage" class="mt-2">
              {{ message.message_src }}
            </div>
          </div>
        </div>

        <div
          v-if="!loadedDeliveries && message.type == 'up' && message.messageStatus !== 'suspended'"
          class="d-flex justify-content-left border-top mt-4 pt-4 pb-4"
        >
          <button class="btn btn-primary" @click="loadDeliveries()">
            {{ $t("nacistDeliveries") }}
          </button>
        </div>

        <AppLoader v-if="loadingDeliveries" id="deliveriesLoading" class="pl-5 pt-2 pb-2" />

        <div
          v-if="!loadingDeliveries && loadedDeliveries && !oldDeliveries && deliveries.length == 0"
          class="border-top pt-4 mesages__timestamps"
        >
          <div id="deliveries" class="mt-3 mb-3">
            <strong>{{ $t("noDeliveries") }}</strong>
          </div>
        </div>

        <div
          v-if="!loadingDeliveries && loadedDeliveries != false && oldDeliveries && deliveries.length == 0"
          class="border-top pt-4 mesages__timestamps"
        >
          <div id="deliveries" class="mt-3 mb-3">
            <strong>{{ $t("noDeliveriesYet") }}</strong>
          </div>
        </div>
        <div
          v-if="!loadingDeliveries && loadedDeliveries && !oldDeliveries && deliveries.length > 0"
          class="border-top pt-4 mesages__timestamps"
        >
          <div id="deliveries" class="mt-3">
            <div class="d-flex">
              <span class="messages__timestamps__col gray-text">{{ $t("datumACas") }}</span>
              <span class="messages__timestamps__col gray-text">{{ $t("akce") }}</span>
              <span class="messages__timestamps__col gray-text code">{{ $t("stav") }}</span>
            </div>
            <div class="d-flex messages__timestamps__item">
              <span class="messages__timestamps__col" v-html="$filters.dateTimeMicro(message.messageTime)" />
              <span class="messages__timestamps__col">{{ $t("ZpravaOdeslanaZeZarizeni") }}</span>
              <span class="messages__timestamps__col code">
                <span class="atom-tag atom-tag--success">{{ $t("OK") }}</span>
              </span>
            </div>

            <div
              v-for="(delivery, index) in deliveriesByTime"
              :key="index + 'd'"
              class="d-flex messages__timestamps__item"
            >
              <span class="messages__timestamps__col" v-html="$filters.dateTimeMicro(delivery.messageTime)" />
              <span class="messages__timestamps__col">
                <RouterLink
                  :to="{
                    name: delivery.custDestType == 'MQTT' ? 'mqttEndpoint' : 'endpoint',
                    params: {
                      id: delivery.custDestId,
                      device: device
                    }
                  }"
                >
                  {{ $t("ZpravaOdeslanaNaEndpoint") }} "{{ delivery.name }}"
                </RouterLink>
              </span>
              <span class="messages__timestamps__col d-block code">
                <span
                  v-if="delivery.code >= 200 && delivery.code < 300"
                  v-tooltip
                  :title="delivery.code + ' ' + delivery.error"
                  class="atom-tag atom-tag--success"
                >
                  {{ $t("OK") }}
                </span>
                <span v-else>
                  <span class="error">{{ $t("nedoruceno") }}</span>

                  <InfoExclamationMarkNoText :info-tooltip="delivery.code + ' ' + delivery.error" />
                </span>
              </span>
            </div>
          </div>
          <!--div v-for="(line,index) in message.message.split(',')" :key="index+'message'">{{line}}</div-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import Loader from "@/components/loader.vue"
import InfoExclamationMarkNoText from "@/components/info/infoExclamationMarkNoText.vue"
//import SignalStrengthIcon from "@/components/boxes/signalStrengthIcon.vue";
import RssiIcon from "@/components/boxes/rssiIcon.vue"
import SnrIcon from "@/components/boxes/snrIcon.vue"
import { client } from "@/main"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"
//import SaveConfirmationModal from "@/components/confirmations/save.vue";
export default {
  components: {
    RssiIcon,
    SnrIcon,
    InfoExclamationMarkNoText,
    AppLoader: Loader
  },
  props: {
    device: Object,
    deviceType: String,
    item: Object,
    opened: Array
  },
  setup() {
    const tfStore = useTransformationFunctionsStore()
    return { tfStore }
  },
  data() {
    return {
      message: {},
      usedTransformations: [],
      loading: false,
      loadingDeliveries: false,
      loadedDeliveries: false,
      showOriginalMessage: false,
      oldDeliveries: false,
      deliveries: []
    }
  },
  computed: {
    transformationFunction() {
      return this.tfStore.detail
    },
    deliveriesByTime() {
      return _.orderBy(this.deliveries, "responseTime", "asc")
      //return this.deliveries;
    }
  },
  watch: {
    writtenEndpointTags() {
      //this.createTagsArray();
    },
    item() {
      this.loadData()
    }
  },
  mounted() {
    // console.log("mounted");

    this.message = this.item
    console.log(this.message)
    this.loadData()
  },
  methods: {
    getTransformationFunction(id) {
      return this.tfStore.getDetail(id)
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetValues()
        this.$emit("closeBox")
      } else {
        //this.errors.group = "";
        this.resetValues()
        this.$emit("closeBox", box)
      }
    },
    setProject() {
      /*this.endpoint.projectId = this.project.projectId;
      this.newGroup.projectId = this.project.projectId;*/
    },
    loadData() {
      console.log("messageShow.vue loadData")
      this.loading = false
      this.deliveries = []
      this.loadedDeliveries = false
      this.message = {}
      this.message = this.item
      this.loadTransformations()
    },
    async loadTransformations() {
      if (
        !this.message.transformationId &&
        !this.message.hwDeviceTransformationId &&
        !this.device.groupTransformationId
      ) {
        return
      }

      const { data } = await client.path("/transformations").method("get").create()({
        "transformationId[in]": [
          this.message.transformationId,
          this.message.hwDeviceTransformationId,
          this.message.groupTransformationId
        ]
          .filter((id) => !!id)
          .toString()
      })
      this.usedTransformations = data.data
    },
    loadDeliveries() {
      this.loadingDeliveries = true
      this.loadedDeliveries = false
      this.oldDeliveries = false
      this.deliveries = []
      let promises = []
      promises.push(
        // TODO používat jednotně deviceType, ideálně jako lowercase pro URL rovnou
        axios
          .get(
            `${process.env.VUE_APP_API}/${this.deviceType === "MQTT" ? "mqtt" : "lora"}/devices/${
              this.device.deviceId
            }/up/messages/${this.message.id}/deliveries`
          ) // TODO používat všude async/await
          .then((result) => {
            console.log("messages result")
            console.log(result)
            if (result.status === 200) {
              console.log("result", result)

              result.data.data.forEach((item) => {
                console.log("item", item)

                let type = item.custDestType === "MQTT" ? "mqtt" : "http"

                axios
                  .get(
                    process.env.VUE_APP_API +
                      "/" +
                      (item.custDestType === "MQTT" ? "mqtt/gateways" : "http/endpoints") +
                      "/" +
                      item.custDestId
                  )
                  .then((item_detail) => {
                    console.log("item_detail", item_detail)

                    this.deliveries.push({
                      messageTime: item.requestTime,
                      code: item.code,
                      error: item.error,
                      name: type == "mqtt" ? item_detail.data.data[0].custDestName : item_detail.data.data.custDestName,
                      custDestType: item.custDestType,
                      custDestId: item.custDestId
                    })

                    this.$nextTick(() => {
                      var elmnt = document.getElementById("deliveries")
                      elmnt.scrollIntoView()
                    })
                  })
                  .catch(() => {
                    console.log("some error")
                  })
              })
            }
          })
          .catch((result) => {
            if (result.status === 303) {
              this.loadedDeliveries = true
              this.loadingDeliveries = false
              this.oldDeliveries = true
            }
          })
      )
      Promise.all(promises).then(() => {
        this.loadedDeliveries = true
        this.loadingDeliveries = false
      })
    },
    exportMessages(type) {
      // while loop
      let messagesToExport = []
      let deviceType = this.deviceType === "MQTT" ? "mqtt" : "lora"
      messagesToExport.push(this.message.message)
      console.log("singleMessage", this.message.message)
      axios
        .post(
          process.env.VUE_APP_APICMS + "/exportMessages?deviceType=" + deviceType + "&format=" + type,
          messagesToExport,
          {
            responseType: "blob"
          }
        )
        .then((response) => {
          if (response.data) {
            let fileNameSuffix = ""
            if (deviceType == "mqtt") {
              fileNameSuffix =
                "_mqtt_" +
                this.device.deviceId +
                "_" +
                this.message.messageTime
                  .replaceAll(":", "_")
                  .replaceAll("-", "_")
                  .replaceAll(".", "_")
                  .replaceAll("Z", "")
            } else {
              let d = new Date(this.message.message.ts + 2 * 60 * 60 * 1000)
              let dateFrom = d.toISOString()

              fileNameSuffix =
                "_" +
                this.device.deviceId +
                "_" +
                dateFrom.replaceAll(":", "_").replaceAll("-", "_").replaceAll(".", "_").replaceAll("Z", "")
            }

            var fileName, blob
            if (type == "csv") {
              fileName = "export" + fileNameSuffix + ".csv"
              console.log("export.fileName", fileName)
              blob = new Blob([response.data], {
                type: "text/csv;charset=utf-8;"
              })
            } else if (type == "xlsx") {
              fileName = "export" + fileNameSuffix + ".xlsx"
              console.log("export.fileName", fileName)
              blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              })
            }

            if (window.navigator.msSaveBlob) {
              // FOR IE BROWSER
              navigator.msSaveBlob(blob, fileName)
            } else {
              // FOR OTHER BROWSERS
              var csvUrl = URL.createObjectURL(blob)
              const link = document.createElement("a")
              link.setAttribute("href", csvUrl)
              link.setAttribute("download", fileName)
              link.click()
            }
          }
        })
        .catch(() => {})
    },
    resetValues() {}
  }
}
</script>

<style lang="scss" scoped>
.warning {
  color: #ef7979;
}
</style>
